module.exports = __webpack_public_path__ + "static/img/207.299a533.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/190926/207.jpg
// module id = s9Zk
// module chunks = 0